<template>
  <div class="page">
    <div class="mask"></div>
    <div class="popup">
      <div class="popup-box">
        <!-- 背景层 -->
        <div class="popup-box-bg"></div>
        <div class="title">{{ localesPackage?.['katharsis_reward']?.[localesEnv] }}</div>
        <div class="content">
          <!-- 道具展示 -->
          <div class="item">
            <!-- 背景框 -->
            <div class="item-bg">
              <img v-if="cur_popup_info?.prop_level === 0" 
                  :src="require('@/assets/images/YuliApp/weeklyTask/item_back_bg_black.svg')">
              <img v-if="cur_popup_info?.prop_level === 1" 
                  :src="require('@/assets/images/YuliApp/weeklyTask/item_back_bg_white.svg')">
              <img v-if="cur_popup_info?.prop_level === 2" 
                  :src="require('@/assets/images/YuliApp/weeklyTask/item_back_bg_green.svg')">
              <img v-if="cur_popup_info?.prop_level === 3" 
                  :src="require('@/assets/images/YuliApp/weeklyTask/item_back_bg_blue.svg')">
              <img v-if="cur_popup_info?.prop_level === 4" 
                  :src="require('@/assets/images/YuliApp/weeklyTask/item_back_bg_purple.svg')">
              <img v-if="cur_popup_info?.prop_level === 5" 
                  :src="require('@/assets/images/YuliApp/weeklyTask/item_back_bg_orange.svg')">
            </div>
            <!-- 道具图片 -->
            <div class="item-icon">
              <img :src="cur_popup_info.icon_url" />
              <!-- <img
                class="yiny"
                :src="require('@/assets/images/YuliApp/weeklyTask/store_wupin_yiny.svg')"/> -->
            </div>
            <!-- 持有数 -->
            <div class="item-owned">
              {{ popup_info.current_holding }}
            </div>
            <!-- 道具名称 -->
            <div class="item-name longTouch">
              {{ cur_popup_info.name.replace(/"/g, "") }}
            </div>
            <!-- 道具描述 -->
            <div class="item-desc longTouch">
              {{ cur_popup_info.desc.replace(/"/g, "") }}
            </div>
          </div>
          
          <!-- 奖励状态 -->
          <div class="content-state" :class="`state${state}`">
            <img
              v-if="state === REWARD_STATE.CLAIMED"
              :src="
                require('@/assets/images/YuliApp/weeklyTask/claimed_yes.svg')
              "
            />
            <img
              v-else
              :src="require('@/assets/images/YuliApp/weeklyTask/lock_gray.svg')"
            />
            {{ state === REWARD_STATE.CLAIMED ? localesPackage?.['og_claimed']?.[localesEnv] : localesPackage?.['og_locked']?.[localesEnv] }}
          </div>

        </div>
        <!-- 关闭图标 -->
        <div class="popup-box-closeIcon" @click="handleClose" v-if="mode === 2">
          <img
            src="@/assets/images/YuliApp/weeklyTask/icon_delete_nor.svg"
          />
        </div>
      </div>
      <!-- 弹窗按钮 -->
      <div class="popup-button" @click="handleClose" v-if="mode !== 2">
        {{ localesPackage?.['og_ok_button']?.[localesEnv] }}
      </div>
      <div class="popup-button popup-button-upgrade" :style="[{width: `${localesEnv == 'ja'?'304px':''}`}]" @click="upgradeHandle" v-else>
        {{ localesPackage?.['og_unlock_button']?.[localesEnv] }}
      </div>
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref } from "vue";
import { REWARD_TYPE } from "@/constants/enums";
import { mapState } from "vuex";

export default {
  props: {
    stateIconUrl: {
      type: String,
      default: require("@/assets/images/YuliApp/weeklyTask/btn_task_yes.svg"),
    },
    iconUrl: {
      type: String,
      default: require("@/assets/images/YuliApp/weeklyTask/goods_icon_exp@2x.png"),
    },
    cur_props_owned: {
      type: Number,
      default: 2,
    },
    state: {
      type: Number,
      default: 3,
    },
    cur_popup_info: {
      type: Object,
      default: null,
    },
    mode: {
      type: Number,
      default: 1,//传2开启upgrade界面，1正常模式
    }
  },
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    cur_popup_info: {
      handler(value) {
        if (!value) {
          return;
        }

        this.popup_info = value;
        this.handleOwnUpdate();
      },
      immediate: true,
      deep: true,
    },
    cur_props_owned: {
      handler(value) {
        this.Owned = value;
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props, {emit}) {
    const { state, mode } = props;
    const REWARD_STATE = ref(REWARD_TYPE);
    const popup_info = ref(null);
    const Owned = ref(0);
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    /**
     * 处理关闭
     */
    const handleClose = () => {
      emit("close", false, state);
    };
    /**
     * upgrade处理
     */
    const upgradeHandle = () => {
      emit("msginfo",'upgrade');
    }

    /**
     * 领取奖励成功之后立即奖励详情还没来得及更新的情况
     */
    const handleOwnUpdate = (data) => {
      const prop_id = localStorage.getItem("prop_id");
      const current_holding = localStorage.getItem("current_holding");

      // console.log(
      //   "判断",
      //   popup_info.value.prop_id === prop_id,
      //   popup_info.value.prop_id,
      //   prop_id
      // );
      if (
        popup_info.value.prop_id === prop_id &&
        popup_info.value.current_holding < current_holding
      ) {
        popup_info.value.current_holding = current_holding;
      }
    };
    return {
      handleClose,
      REWARD_STATE,
      popup_info,
      Owned,
      handleOwnUpdate,
      upgradeHandle,
      localesPackage,
      localesEnv
    };
  },
};
</script>

<style lang="less" scoped>
//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}

.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
  }
  .popup {
    position: absolute;
    z-index: 9999;
    width: 100%;
    height: 264px;
    top: 20%;
    text-align: center;
    &-box {
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 350px;
      height: 390px;
      background: #F6FAFD;
      margin: auto;
      position: relative;
      border-radius: 10px;
      &-bg{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 350px;
        height: 390px;
        background: url("~@/assets/images/YuliApp/weeklyTask/popup_bg.png")
          no-repeat top left;
        background-size: 100% 100%;
        z-index: 0;
      }
      .title {
        width: 348.06px;
        height: 41.09px;
        // background: url("~@/assets/images/YuliApp/weeklyTask/popup_top_img@2x.png")
        //   no-repeat top left;
        // background-size: 100% 100%;
        z-index: 1;
        color: #484C58;
        
        font-size: 18px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: center;
        line-height: 41px;
      }
      .content {
        width: 319px;
        margin: -1px 0 0 1.1px;
        padding-top: 25px;
        display: flex;
        align-items: center;
        flex-direction: column;
        z-index: 2;
        // background: url("~@/assets/images/YuliApp/weeklyTask/popup_bg_content.png")
        //   no-repeat top left;
        // background-size: 100% 100%;

        &-state {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 307px;
          height: 60px;
          opacity: 1;
          margin-top: 28px;
          background: linear-gradient(
            90deg,
            rgba(239, 246, 241, 1) 0%,
            rgba(209, 235, 201, 1) 37%,
            rgba(209, 235, 201, 1) 64%,
            rgba(239, 246, 241, 1) 100%
          );
          color: rgba(92, 215, 209, 1);

          font-size: 22px;
          font-weight: 500;
          font-family: "PingFang HK";
          text-align: left;
          line-height: 26.4px;
          img {
            width: 38px;
            height: 38px;
            margin-right: 4px;
            margin-top: -4px;
          }
        }
        .state2 {
          background: linear-gradient(
            90deg,
            rgba(239, 246, 241, 1) 0%,
            rgba(209, 235, 201, 1) 37%,
            rgba(209, 235, 201, 1) 64%,
            rgba(239, 246, 241, 1) 100%
          );
          color: rgba(30, 122, 67, 1);
          // margin-bottom: 10px;
        }
        .state0 {
          background: linear-gradient(
            90deg,
            rgba(205, 209, 216, 0) 0%,
            rgba(205, 209, 216, 0.4) 37%,
            rgba(205, 209, 216, 0.4) 64%,
            rgba(205, 209, 216, 0) 100%
          );
          color: rgba(79, 83, 86, 1);
          // margin-bottom: 10px;
          img {
            margin-right: 8.5px;
          }
        }
      }
      .bottomIcon {
        position: relative;
        margin: -2px 0 0 1px;
        width: 320px;
        height: 20px;
        img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
      }
      &-closeIcon{
        width: 42px;
        height: 42px;
        position: absolute;
        top: -1px;
        right: 21px;
        z-index: 20;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    &-button {
      width: 128px;
      height: 38px;
      border-radius: 37px;
      background: rgb(66, 59, 106);
      color: rgb(255, 255, 255);
      font-size: 16px;
      font-weight: 600;
      font-family: "PingFang SC";
      text-align: center;
      line-height: 38px;
      position: absolute;
      right: 50%;
      bottom: -118px;
      transform: translateX(50%);
      z-index: 20;
    }
    &-button-upgrade{
      width: 224px;
      z-index: 1000;
    }
  }
}
.item{
  width: 318px;
  height: 120px;
  position: relative;
  .item-bg{
    width: 318px;
    height: 120px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .item-icon{
    width: 76px;
    height: 76px;
    position: absolute;
    top: 15px;
    right: 18px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .item-owned{
    width: 69px;
    opacity: 1;
    color: #000000ff;
    font-size: 15px;
    font-weight: 500;
    font-family: "PingFang HK";
    text-align: center;
    position: absolute;
    right: 5px;
    bottom: 2px;
  }
  .item-name{
    width: 232px;
    height: 19px;
    opacity: 1;
    color: #ffffffff;
    font-size: 16px;
    font-weight: 500;
    font-family: "PingFang SC";
    text-align: left;
    position: absolute;
    top: 12px;
    left: 13px;
  }
  .item-desc{
    width: 208px;
    height: 64px;
    opacity: 1;
    color: #EEF6FA;
    font-size: 13px;
    font-weight: 400;
    font-family: "PingFang SC";
    text-align: left;
    position: absolute;
    top: 35px;
    left: 13px;
  }
}
</style>
